import { styled, Typography, Radio } from '@mui/material';
import { palette } from 'assets/styles/colors';

export const StyledBox = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

export const StyledTypography = styled(Typography)`
  padding: 10px 0px 10px 10px;
`;

export const StyledRadio = styled(Radio)`
  color: ${palette.neutral[200]};
`;
